import React from 'react';
import {getStyle} from "../../services/Style";
import {Link} from "react-router-dom";

class ApplyButton extends React.Component {

    constructor(props){
        super(props);
		let applyButton = getStyle(this.props.positionId, 'primary-button', this.props.customerName);
		let applyButtonHover = getStyle(this.props.positionId, 'primary-button-hover', this.props.customerName);
		if(Object.entries(applyButtonHover).length === 0) {
			applyButtonHover = applyButton;
		}
		this.state = ({
			applyButton: applyButton,
			applyButtonHover: applyButtonHover,
			buttonStyle: applyButton
		});
	}
    changeToHoverStyle = (hover) => {
        let {applyButton, applyButtonHover} = this.state;
        if(hover){
            this.setState({buttonStyle: applyButtonHover?applyButtonHover:applyButton})
        }else{
            this.setState({buttonStyle: applyButton})
        }
    };
    render(){
       const {buttonStyle} = this.state;
       let alreadyAppliedPositions = JSON.parse(sessionStorage.getItem('assignedToPositions-'+this.props.customerName));
       if( alreadyAppliedPositions !== undefined && alreadyAppliedPositions !== null && alreadyAppliedPositions.indexOf(this.props.positionId) !== -1 ){
           return  <a  title={window.Translator.getSlug('AlreadyApplied', this.props.language)}
                      style={buttonStyle}
                      onMouseOver={ () => this.changeToHoverStyle(true) }
                      onMouseLeave={ () => this.changeToHoverStyle(false) }
                      id={'positionApplyButton'}
                      className={"col-12 col-xs-6 col-md-4 apply isDisabled"}
                      >
               {window.Translator.getSlug('ApplyNow', this.props.language)}
           </a>
       }
       return (
           <Link
               style={buttonStyle}
               onMouseOver={ () => this.changeToHoverStyle(true) }
               onMouseLeave={ () => this.changeToHoverStyle(false) }
               className={"col-12 col-xs-6 col-md-4 apply"}
               to={'/'+this.props.language+'/gate/'+this.props.customerName+'/register/'+this.props.positionId}
           >{window.Translator.getSlug('ApplyNow', this.props.language)}</Link>
       );
    }
}

export default ApplyButton;
